import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { useState } from "react";

export function UseOrders() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();
  const [locations, setLocations] = useState([]);

  const setLocationData = (locationData) => {
    setLocations(locationData);
  };

  const getOrdersList = (
    myPC,
    searchColumn,
    State,
    Filter,
    search,
    callback,
    bool
  ) => {
    let newMypc = myPC;
    if (searchColumn || searchColumn == null) {
      newMypc.searchColumn = searchColumn;
    }
    if (State && State == 1) {
      newMypc.sortOrder = "asc";
    } else {
      newMypc.sortOrder = "desc";
    }
    MyAxios.get(`Admin_Orders/${State}/${Filter}?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: newMypc }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getOrdersLoc = (orderID, callback) => {
    MyAxios.get(`Admin_Orders/AdminOrder_Info/${orderID}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const EditOrderInfo = (orderID, callback) => {
    MyAxios.get(`Admin_Orders/AdminEditOrder_Info/${orderID}`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  const getOrderByID = (id, callback) => {
    MyAxios.get(`Admin_Orders/${id}`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
            searchText: "",
            scrollTo: undefined,
            forceRefresh: false,
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateOrder = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Orders/UpdateOrder`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const ConfirmOrder = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Orders/ConfirmOrder`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("سفارش با موفقیت تایید شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const CancelOrder = (OrderID, callback) => {
    const data = new FormData();
    data.append("OrderID", OrderID);
    MyAxios.post(`Admin_Orders/CancelOrder`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("سفارش با موفقیت کنسل شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addressPrint = (OrderID, callback) => {
    const data = new FormData();
    data.append("OrderID", OrderID);
    MyAxios.post(`Admin_Orders/DeliveryAddress`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const Waiting = (model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(model));
    MyAxios.post(`Admin_Orders/Waiting`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("سفارش در انتظار شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const UpdateOrderFinancial = (model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(model));
    MyAxios.post(`Admin_Orders/UpdateOrderFinancial`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        if (model.FinancialID == 1) {
          enqueueSnackbar("سفارش به حسابرسی ارسال شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
        } else if (model.FinancialID == 2) {
          enqueueSnackbar("سفارش توسط حسابرسی تایید شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
        } else if (model.FinancialID == 3) {
          enqueueSnackbar("سفارش توسط حسابرسی تایید نشد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
        }
        callback();
      }
    });
  };

  const SetEmoji = (model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(model));
    MyAxios.post(`Admin_Orders/SetEmoji`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("آواتار کاربر ثبت شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const postsms = (OrderID) => {
    const data = new FormData();
    data.append("OrderID", OrderID);
    MyAxios.post(`Admin_Orders/postsms`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("ارسال شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
      }
    });
  };

  const factorPrint = (OrderID, callback) => {
    const data = new FormData();
    data.append("OrderID", OrderID);
    MyAxios.post(`Admin_Orders/Factor`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const CancelInstallmentOrder = (orderID, callback) => {
    MyAxios.get(`Admin_Orders/CancelInstallmentOrder/${orderID}`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("با موفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback(response.data.resault);
        }
      }
    );
  };

  const getProvinceById = (id) => {
    return locations.find((m) => (m.id = id));
  };

  return {
    getOrdersList,
    getOrderByID,
    updateOrder,
    setLocationData,
    getProvinceById,
    locations,
    getOrdersLoc,
    addressPrint,
    factorPrint,
    ConfirmOrder,
    CancelOrder,
    Waiting,
    SetEmoji,
    UpdateOrderFinancial,
    postsms,
    EditOrderInfo,
    CancelInstallmentOrder,
  };
}
